var FrameContainer = require('./FrameContainer'),
    utils = require('@axd/widgets-utils');


var settings = {
    coursetalkUrl: CT_ENV_HOST
};

var FrameContainerNextGen = FrameContainer.create({

    getBasePath: function () {
        var mode = '';
        if (this.mode && this.mode == 'read') {
            mode = 'read';
        }
        if (this.mode && this.mode == 'write') {
            mode = 'write';
        }
        var fitst_part = '/widgets/v2.0/';
        return utils.join(fitst_part + mode, 'iframe-review-widget/');
    },

    _template: function () {
        return '<iframe src="' + utils.join(settings.coursetalkUrl, this._getFrameURL()) + '" id="ct_widget_iframe" ' +
            'class="ct-next-gen-widget" style="display: none" scrolling="no"></iframe>';
    }

});

module.exports = FrameContainerNextGen;



/*****************
 ** WEBPACK FOOTER
 ** ./client/helpers/FrameContainerNextGen.js
 ** module id = 6
 ** module chunks = 0
 **/